
import { scheduleData } from '../../../mocks/schedule';

export default function Schedule() {
  return (
    <section id="schedule" className="py-32 px-6 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-light mb-6 tracking-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            Event Schedule
          </h2>
          <p className="text-lg text-gray-600">
            Three days of fashion, culture, and innovation
          </p>
        </div>

        <div className="space-y-16">
          {scheduleData.map((day, index) => (
            <div key={index}>
              <div className="flex items-center gap-6 mb-8">
                <div className="text-6xl font-light text-[#14B8A6]" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {day.day}
                </div>
                <div>
                  <h3 className="text-2xl font-light tracking-wide">{day.date}</h3>
                  <p className="text-gray-500">{day.theme}</p>
                </div>
              </div>

              <div className="space-y-6">
                {day.events.map((event, idx) => (
                  <div key={idx} className="flex gap-8 items-start bg-white p-6 hover:shadow-lg transition-shadow">
                    <div className="text-sm text-gray-500 w-24 flex-shrink-0 tracking-wide">
                      {event.time}
                    </div>
                    <div className="flex-1">
                      <h4 className="text-xl font-light mb-2">{event.title}</h4>
                      <p className="text-gray-600 text-sm">{event.description}</p>
                      {event.designer && (
                        <p className="text-[#14B8A6] text-sm mt-2 tracking-wide">{event.designer}</p>
                      )}
                    </div>
                    {event.vipOnly && (
                      <span className="text-xs bg-[#14B8A6] text-white px-3 py-1 tracking-wider whitespace-nowrap">
                        VIP
                      </span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
